import { Signup } from "components/auth";

const SignupPage = () => {
  return (
    <>
      <Signup />
    </>
  );
};
export { SignupPage };
